var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-2"},[_c('EventLog',{attrs:{"type":"admin"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }